import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ContractsContextProvider } from './ContractsContext';
import ListContracts from './ListContracts';
import { subRoutes } from '../../utils/constants/routes';
import ShowContract from './ShowContract';
import ListTickets from '../tickets/ListTickets';
import Customers from '../customers/Customers';
import Customer from '../customers/Customer';
import ListAmendments from '../amendments/ListAmendments';

const ContractsRouter = () => {
  return (
    <ContractsContextProvider>
      <Routes>
        <Route
          path={`${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/:id`}
          element={<Customer />}
        />
        <Route
          path={subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}
          element={<Customers />}
        />
        <Route
          path={subRoutes.CONTRACTS.PORTFOLIO_AMENDMENTS}
          element={<ListAmendments />}
        />
        <Route
          path={`${subRoutes.CONTRACTS.PORTFOLIO_AMENDMENTS_IN_EXEMPTION}/show/:id`}
          element={<ShowContract />}
        />
        <Route
          path={subRoutes.CONTRACTS.PORTFOLIO_AMENDMENTS_IN_EXEMPTION}
          element={<ListTickets />}
        />
        <Route
          path={`${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}/show/:id`}
          element={<ShowContract />}
        />
        <Route
          path={subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}
          element={<ListContracts />}
        />
        <Route path="show/:id" element={<ShowContract />} />

        <Route index element={<ListContracts />} />
      </Routes>
    </ContractsContextProvider>
  );
};

export default ContractsRouter;
